import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { Property, PropertyImage } from '../../models/property.model';
import { User } from '../../../../shared/user/models/user.model';
import { filter, Subscription, tap } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { PropertyLikeService } from '../../services/property-like.service';
import { Router, RouterLink } from '@angular/router';
// import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { Location } from '../../../../shared/general/models/location.model';
// import { PropertyDialog } from '../property-dialog/property-dialog';
import { environment } from '../../../../../environments/environment';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { SheetService } from '../../../../shared/services/sheet.service';
import { ShareService } from '../../../../shared/services/share.service';
import { ShareButtonComponent } from "../../../../shared/general/components/share-button/share-button";
import { SaveButtonComponent } from "../save-button/save-button";
import { LoaderComponent } from '../../../../shared/general/components/loader/loader.component';
// import { DynamicSheetComponent } from '../../../../shared/general/components/dynamic-sheet/dynamic-sheet';

@Component({
  selector: 'app-property-card-simple',
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatBottomSheetModule,
    RouterLink,
    TitleCasePipe,
    MatProgressSpinner,
    ShareButtonComponent,
    SaveButtonComponent,
    LoaderComponent
],
  templateUrl: './property-card-simple.html',
  styleUrl: './property-card-simple.scss',
})
export class PropertyCardSimple implements OnInit, OnChanges {
  private authService = inject(AuthService);
  private likeService = inject(PropertyLikeService);
  private router = inject(Router);
  private shareService = inject(ShareService);
  sheetService = inject(SheetService);

  @Input() property: Property | undefined;
  @Output() likedChange = new EventEmitter<Property>();
  @Output() selectedProperty = new EventEmitter<Property>();
  private titlecase = new TitleCasePipe();
  mainImg: PropertyImage | undefined;
  user: User | null = null;
  username: string | null = null;
  isLoading = true;
  private isUpdating = false;
  locations: Location[] = [];
  private userSubscription: Subscription | undefined;
  platformId = inject(PLATFORM_ID);

  ngOnInit() {
    this.mainImg = this.property?.images.filter(img => img.sortOrder == 0)[0] ?? this.property?.images[0] ?? undefined;

    this.userSubscription = this.authService.user$.pipe(
      filter((user) => user !== undefined), // Prevent undefined emissions
      tap((user) => {
        this.isLoading = false;
        if (user) {
          this.user = user;
          this.username = user.username;
        }
      })
    ).subscribe();

    this.updateLocations();
  }

  ngOnChanges(changes: SimpleChanges) {
    // this.property = changes['property'].currentValue;
    // this.updateLocations();

    if (changes['property'] && changes['property'].currentValue) {
      //console.log('🔄 Property changed:', changes['property'].currentValue.address.street);
      this.property = changes['property'].currentValue;
      this.mainImg = this.property?.images[0] ?? undefined;
      this.updateLocations();  // ✅ NOW WORKS!
    }
  }

  onThumbnailClick(image: PropertyImage | string): void {
    //console.log('property card thumbnail click', image);
    this.mainImg = typeof image === 'string' ? undefined : image;
  }
  
  updateLocations() {
    if (this.isUpdating) return;  // ✅ STOP DUPLICATES!
    this.isUpdating = true;
  
    //console.log('📍 updateLocations - Property:', this.property?.address.street);
    if (this.property?.address?.lat && this.property?.address?.lng) {
      this.locations = [{
        lat: this.property.address.lat,
        lng: this.property.address.lng,
        name: `${this.property.displayName ?? this.property.propertyType}, ${this.property.address.city}, ${this.property.address.state}`,
        imageUrl: this.property.images[0].imageUrl ?? '',
        liked: this.property.liked 
      }];
      //console.log('✅ locations UPDATED:', this.locations[0].name);
    }
    this.isUpdating = false;
  }
    // console.log('property card updateLocations');
    // if(this.property) { 
    //   console.log('propertyLocations');
    //   this.locations = [];
    //   this.locations.push({
    //     lat: this.property?.address.lat,
    //     lng: this.property?.address.lng,
    //     name: `${this.property.address.street}, ${this.property.address.city}, ${this.property.address.state}`,
    //     liked: this.property.liked 
    //   });
    //   console.log('property card locations', this.locations);
    // }

    // console.log('📍 updateLocations - Property:', this.property?.address.street);
    // // ✅ ALWAYS CREATE LOCATION FROM CURRENT PROPERTY
    // if (this.property?.address?.lat && this.property?.address?.lng) {
    //   this.locations = [{
    //     lat: this.property.address.lat,
    //     lng: this.property.address.lng,
    //     name: `${this.property.address.street}, ${this.property.address.city}, ${this.property.address.state}`,
    //     liked: this.property.liked 
    //   }];
    //   console.log('✅ locations UPDATED:', this.locations[0].name);
    // }

    // console.log('📍 updateLocations - Property:', this.property?.address.street);
    // if (this.property && this.property.address.lat && this.property.address.lng) {
    //   this.locations = [{
    //     lat: this.property.address.lat,
    //     lng: this.property.address.lng,
    //     name: `${this.property.address.street}, ${this.property.address.city}, ${this.property.address.state}`,
    //     liked: this.property.liked 
    //   }];
    //   console.log('✅ locations UPDATED:', this.locations[0].name);
    // } else {
    //   this.locations = [];  // ✅ Clear if no coords
    //   console.log('⚠️ No lat/lng - locations cleared');
    // }


  // toggleLike(event: any) {
  //   //console.log('prop liked', event);
  //   if(this.property !== undefined) {
  //     this.onPropertyLiked();
  //   }
  // }

  viewProperty = () => {
    //console.log('viewProperty clicked', this.property?.id);
    console.log('this.property', this.property);
    this.router.navigate(['/property', this.property?.id])
    .then(success => console.log('Navigation success:', success))
    .catch(err => console.error('Navigation error:', err));
    
    // this.sheetService.open(PropertyView, {
    //   inputProperty: this.property 
    // });
  }

  getPropertyTitle() {
    if (this.property) {
      return `${this.titlecase.transform(`${ this.property.displayName ?? this.property.propertyType } in ${this.property.address.city}, ${this.property.address.state}`)}`;
    }
    return '';
  }

  getPropertyUrl() {
      return this.property ? `${environment.appUrl}/property/${this.property.id}` : environment.appUrl;
  }
  
  onPropertyLiked(): void {
    const userId = this.user?.id ?? null;
    if (this.property !== undefined) {
      const property = this.property;

      this.likeService.toggleLike(this.property.id).pipe(tap((response: any) => {
        //console.log(`${response.action} property ${property.id}`);
        property.liked = response.action === 'liked';
        this.likedChange.emit(property);
      })).subscribe();
    }
  }

  // 🔥 SHARE PROPERTY (Native Share Sheet)
  async shareProperty() {
    const property = this.property;
    if (property) {
      const propertyUrl = `${environment.appUrl}/#/property/list?state=${this.property?.address.state}&property=${this.property?.id}`;
      // try {
        // Create share text
      const propertyTitle = `${ this.titlecase.transform(property?.propertyType) } in ${property?.address.city}, ${property?.address.state}`;
      const propertyDetails = `
          🏠 ${ this.titlecase.transform(propertyTitle) }
          📸 ${property?.images[0].imageUrl}
          `.trim();

      this.shareService.share(propertyTitle, propertyDetails, propertyUrl);
    }
  }

        // // Native Share API (Mobile)
        // if (navigator.share) {
        //   await navigator.share({
        //     title: propertyTitle,
        //     text: propertyDetails,
        //     url: propertyUrl,
        //   });
        //   console.log('✅ Shared via native sheet!');
        // } 
        // // Web Share Fallback (Desktop/Mobile)
        // else {
        //   // Copy to clipboard + prompt
        //   await navigator.clipboard.writeText(propertyDetails);
        //   alert(`✅ Copied to clipboard!\n\n${propertyTitle}\n\nPaste anywhere!`);
        // }
      // } catch (error) {
      //   console.error('Share error:', error);
      //   // Fallback: Open WhatsApp/Twitter links
      //   this.shareFallback(`${property?.propertyType} in ${property?.address.city}, ${property?.address.state}`, `
      //       🏠 ${property?.propertyType} in ${property?.address.city}, ${property?.address.state}
      //       📸 ${property?.images[0].imageUrl}
      //       `.trim());
      // }

  // Fallback for browsers without Web Share API
  private shareFallback(title: string, text: string) {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(title + '\n\n' + text)}`;
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title + '\n\n' + text)}`;
    
    const shareLinks = `
  📱 **Share Options:**
  • WhatsApp: ${whatsappUrl}
  • Twitter: ${twitterUrl}
  • Copy: *(Already copied!)*
    `;
    
    alert(shareLinks);
    // Optional: Open WhatsApp
    window.open(whatsappUrl, '_blank');
  }

  // 🔥 IMAGE VIEWER PROPERTIES
  showImageViewer = false;
  viewerImageUrl = '';
  viewerImageDescription = '';
  currentImageIndex = 0;

  // ✅ OPEN MAIN IMAGE (Your existing click handler)
  openMainImage() {
    console.log('open main img');
      if (this.mainImg) {
          this.viewerImageUrl = this.mainImg.imageUrl;
          this.viewerImageDescription = this.mainImg.description || 'Property image';
          this.currentImageIndex = 0;
          this.showImageViewer = true;
      }
  }

  // 🔥 CLOSE VIEWER
  closeImageViewer() {
      this.showImageViewer = false;
  }

  // 🔥 PREVIOUS IMAGE
  prevImage() {
      if (this.property?.images && this.currentImageIndex > 0) {
          this.currentImageIndex--;
          this.viewerImageUrl = this.property.images[this.currentImageIndex].imageUrl;
          this.viewerImageDescription = this.property.images[this.currentImageIndex].description || '';
      }
  }

  // 🔥 NEXT IMAGE
  nextImage() {
      if (this.property?.images && this.currentImageIndex < this.property.images.length - 1) {
          this.currentImageIndex++;
          this.viewerImageUrl = this.property.images[this.currentImageIndex].imageUrl;
          this.viewerImageDescription = this.property.images[this.currentImageIndex].description || '';
      }
  }
}
